<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <div class="handler">
        <el-tabs
          class="tab"
          v-model="currentCard"
          size="small"
          
          @tab-click="handleClick"
        >
          <!--直播管理类型(1 基础信息、2 授权观看、3 回放设置-->
          <el-tab-pane v-for="item in headTabList" :label="item.paramValue" :name="item.paramKey" :key="item.paramKey"></el-tab-pane>
        </el-tabs>
        <butn class="trash" btntype="primary" title="返回" @click="$router.push({path: '/liveManage'})" iconName="el-icon-arrow-left"></butn>
      </div>
    </div>
    <!--基础信息-->
    <BaseInfo :detailInfo="detailInfo" :liveRoomId="liveRoomId" v-if="currentCard == '1'" />
    <!--授权观看-->
    <el-tabs v-else-if="currentCard == '2'" v-model="authorizedActiveTab" type="card" @tab-click="handleAuthorizedClick">
      <el-tab-pane label="授权用户" name="user">
        <AuthorizedView :detailInfo="detailInfo" />
      </el-tab-pane>
      <el-tab-pane label="授权范围" name="range" lazy>
        <AuthorizedRangeView :detailInfo="detailInfo" />
      </el-tab-pane>
    </el-tabs>
    
    <!--回放设置-->
    <div class="teaching_page" v-if="currentCard == '3'" >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        label-width="110px"
        class="form"
      >
        <el-form-item label="关联回放视频" prop="bizId">
          <load-select
            style="width: 500px"
            v-model="ruleForm.bizId"
            dictLabel="bizName"
            dictValue="bizId"
            :data="data"
            :page="page"
            :hasMore="more"
            :request="getData"
            placeholder="请选择视频（请在视频管理中上传“直播”类型视频）"
            :defaultVal="ruleForm.bizName"
            :isInit="isInit"
            @change="sourceChange"
            @ChangeValue="changeValue"
          />
        </el-form-item>
        <el-form-item class="bottom_style">
          <butn title="取消" @click="resetForm" :disabled="isEdit"></butn>
          <butn title="提交" btntype="primary" @click="onSubmit" :disabled="isEdit"></butn>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import AuthorizedView from "./authorizedView/index";
import AuthorizedRangeView from "./authorizedRange/index.vue";
import LoadSelect from "@/components/load-select/index.vue";
import BaseInfo from "./baseInfo/index";
import { getLiveRoomInfo, getLiveResourceList, bindLiveVideo } from "@/api/video";

export default {
  name: "liveRoomManage",
  components: {
    butn,
    BaseInfo,
    AuthorizedView,
    LoadSelect,
    AuthorizedRangeView
  },
  
  data() {
    return {
      page: 1,
      more: true,
      data: [],
      isInit: true,
      headTabList: [],
      isEdit: false,
      ruleForm: {
        bizId: ""
      },
      rules: {
        bizId: [
          {
            required: true,
            message: "请选择视频"
          }
        ]
      },
      detailInfo: {},
      liveRoomId: "",
      currentCard: "1",
      authorizedActiveTab: "user",
    };
  },
  created() {
    this.liveRoomId = this.$route.query.liveRoomId;
    this.currentCard = this.$route.query.active || '1';
    this.getDetail();
    this.getSysParamByTypes(["LIVE_MANAGE_ENUM"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        this.headTabList = res.data["LIVE_MANAGE_ENUM"];
      });
    },
    // 基础信息
    getDetail() {
      getLiveRoomInfo(this.liveRoomId).then(({ code, data }) => {
        if (code === 0) {
          this.detailInfo = data || {};
          this.ruleForm.bizId = data.bizId;
          this.ruleForm.bizName = data.bizName;
          if (this.ruleForm.bizId) {
            this.isEdit = true;
          }
        }
      });
    },
    sourceChange() {
      this.isInit = false;
    },
    changeValue(val) {
      let item = this.data.filter((item) => item.bizId == val)[0];
      this.ruleForm.bizName = item.bizName;
    },
    getData({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve) => {
        getLiveResourceList({ page, bizName: keyword }).then(({ code, data }) => {
          if (code !== 0) return;
          if (more) {
            this.data = [...this.data, ...data.records];
          } else {
            this.data = data.records;
          }
          this.page = data.current;
          let { current, total, size } = data;
          this.more = current * size < total;
          this.page = current;
          resolve();
        });
      });
    },
    // 重置表单
    async resetForm() {
      this.ruleForm.bizId = "";
      this.ruleForm.bizName = "";
    },
    handleClick(tab) {
      // 直播管理类型(1 基础信息、2 授权观看、3 回放设置
    },
    handleAuthorizedClick(tab) {
      
    },
    onSubmit() {
      if (this.ruleForm.bizId) {
        this.$confirm(`关联回放视频设置后不允许修改，确认设置该视频为回放视频吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.loading = true;
          let params = {
            liveRoomId: this.liveRoomId,
            bizId: this.ruleForm.bizId,
            bizName: this.ruleForm.bizName
          };
          bindLiveVideo(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              this.getDetail();
            }
          });
        }).catch(() => {});
      } else {
        this.$message.warning("请选择关联回放视频！");
      };
    },
  }
};
</script>
<style lang="scss" scoped>
.bottom_style {
  text-align: left;
  margin-top: 100px;
}
/deep/.teaching_page .el-form-item__content {
  margin-left: 116px !important;
}
.content {
  width: 50%;
}
.filter_container {
  padding-bottom: 15px !important;
}
.fileName {
  font-size: 12px;
  .preview_text {
    color: #3A85FF;
    margin-left: 18px;
    text-decoration: none;
  }
}
.handler {
  position: relative;
  .tab {
    width: 100%;
  }
  .trash {
    position: absolute;
    right: 0;
    top: 5px;
  }
}
</style>
